
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import router from "@/router";

import { LOGIN_USER, TRANSLATIONS_FETCH } from "@/store/ActionTypes";
import { AuthStates } from "@/store/modules/AccountModule";

import UserLogin from "@/models/User/UserLogin";
import { UserTypes } from "@/models/User/UserTypes";

@Component({
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule
    })
  }
})
class AdminLogin extends Vue {
  user: UserLogin = { email: "", password: "", rememberMe: false };

  localizationState: any;

  attemptLogin() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        // @ts-ignore
        this.$snotify.async(
          this.translations.get("login_authenticating"),
          () =>
            new Promise((resolve, reject) => {
              this.$store
                .dispatch(LOGIN_USER, this.user)
                .then((response) => {
                  if (
                    [UserTypes.Administrator, UserTypes.SuperAdministrator, UserTypes.Helpdesk].includes(response.data.result.userType)
                  ) {
                    router.push("/administration");
                  }
                  else {
                    router.push("/");
                  }
                  resolve({ body: "Welcome!" });
                })
                .catch(() => {
                  reject({ body: this.$store.getters.getAuthMessage });
                });
            }),
          {
            timeout: 3500,
            closeOnClick: true
          }
        );
        return;
      }
      this.$snotify.error(this.translations.get("validation-error-message"));
    });
  }

  get translations() {
    return this.localizationState.translations;
  }

  created() {
    this.$store.dispatch(TRANSLATIONS_FETCH, {
      category: "pages",
      collections: ["login", "common"]
    });

    document.title = 'Administrator Login | MenuSano';
  }

  get showMessage() {
    if (this.$store.getters.getAuthState === AuthStates.Failed) return true;
  }
}
export default AdminLogin;
